import { FormlyFieldConfig } from '@ngx-formly/core';
import { RxDocument, RxCollection, RxJsonSchema, RxCollectionCreator } from 'rxdb';

export interface DataSchemaDocType {
  aps_report_load_id: string;
  assigned_agent_id: number;
  data: any;
}

export const dataSchema: RxJsonSchema<DataSchemaDocType> = {
  title: 'formly schema',
  description: 'this is the data schema',
  version: 0,
  keyCompression: true,
  type: 'object',
  properties: {
      aps_report_load_id: {
        type: 'string',
        primary: true
      },
      assigned_agent_id: {
        type: 'number'
      },
      data: {
        type: 'object',
        encrypted: true
      },
  }
};

export type DataSchemaDocument = RxDocument<DataSchemaDocType>;
export type DataSchemaCollection = RxCollection<DataSchemaDocType>;

export const dataSchemaCollection: RxCollectionCreator = {
  name: 'form_data',
  schema: dataSchema
};
